<template>
  <div>
    <b-container>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(next)" autocomplete="off">
          <b-card>
            <template #header>
              <h6 class="mb-0">Antigüedad de la póliza</h6>
            </template>

            <p class="text-muted small mb-3">
              ¿Ha estado alguna vez asegurado en alguna póliza colectiva de vida o salud?
            </p>

            <b-form-group>
              <RadioComponent :form="form" name="continuidadPoliza" :options="control.TIPOS_SINO" rules="required" />
            </b-form-group>

            <template v-if="form.continuidadPoliza === 'S'">
              <b-row class="mb-3">
                <b-col md="8" cols="12" class="mb-2 mb-md-0">
                  <TextComponent
                    :form="form"
                    name="nombreTomadorPoliza"
                    label="Nombre del tomador de la póliza"
                    rules="required"
                  />
                </b-col>

                <b-col md="4" cols="12">
                  <DateComponent
                    :form="form"
                    name="fechaSeguro"
                    label="Fecha del seguro (mm/dd/aaaa)"
                    rules="required"
                  />
                </b-col>
              </b-row>
            </template>

            <b-row align-h="end" class="mt-4">
              <b-col md="4" cols="4" style="display: flex; justify-content: flex-end">
                <b-button @click="previous" variant="secondary">Anterior</b-button>
                <b-button type="submit" variant="primary">Siguiente</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </validation-observer>
    </b-container>
  </div>
</template>

<script>
import DateComponent from "@/components/controls/DateComponent.vue";

import RadioComponent from "@/components/controls/RadioComponent.vue";
import TextComponent from "@/components/controls/TextComponent.vue";
import { TIPOS_SINO } from "@/data/colombia/salud/Selects";

function nombreCompletoPersona(persona) {
  return [persona.name, persona.lastName, persona.secondLastName]
    .map((s) => (s || "").trim())
    .filter(Boolean)
    .join(" ")
    .trim();
}

export default {
  name: "FormColombiaSalud05",
  components: { RadioComponent, TextComponent, DateComponent },
  data() {
    return {
      control: { TIPOS_SINO },
      form: {},
    };
  },
  mounted() {
    this.$store.dispatch("app/loading", true);
    const { form } = this.$store.state.wizard;
    if (form === undefined || form === null || form === "") {
      this.$router.push("/form/colombia/salud/");
      return;
    }
    this.form = form;
    if (this.form.nombreTomadorPoliza === undefined) this.form.nombreTomadorPoliza = "";
    if (this.form.fechaSeguro === undefined) this.form.fechaSeguro = "";
    const personasConDatos = this.form.dependientes || [];
    const existing =
      this.form.continuidadDetalle && Array.isArray(this.form.continuidadDetalle) ? this.form.continuidadDetalle : [];

    this.form.continuidadDetalle = personasConDatos.map((persona, i) => ({
      nombreSolicitante: nombreCompletoPersona(persona) || (persona.name || "").trim() || "",
      compania: (existing[i] && existing[i].compania) || "",
      plan: (existing[i] && existing[i].plan) || "",
      fechaInicio: (existing[i] && existing[i].fechaInicio) || "",
      numPolizaContrato: (existing[i] && existing[i].numPolizaContrato) || "",
      fechaVencimiento: (existing[i] && existing[i].fechaVencimiento) || "",
    }));
    this.$store.dispatch("app/loading", false);
  },
  methods: {
    previous() {
      this.$store.dispatch("wizard/save", { index: 4, form: this.form }).then(() => {
        if (this.form.saltoForm04) {
          this.form.saltoForm04 = false;
          this.$router.push("/form/colombia-salud-3.html");
        } else {
          this.$router.push("/form/colombia-salud-4.html");
        }
      });
    },
    next() {
      this.$store
        .dispatch("wizard/save", { index: 5, form: this.form })
        .then(() => this.$router.push("/form/colombia-salud-6.html"));
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 100%;
}
</style>
